'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const CommentRepository = require('communication/domain/repository/comment');
const CommentPartialPageCollection = require('communication/domain/collection/comment-partial-page-collection');
// const CommentCollection = require('communication/domain/collection/comment');
const Comment = require('communication/domain/entity/comment');

class CommentCollectionRepository {
    constructor(project) {
        this._project = project;
        this._repo = CommentRepository.find(project);
        this._commentsByKey = {};
        this._draftComment = {};
    }

    byKey(key) {
        let comments = this._commentsByKey[key];
        if(!comments) {
            comments = CommentPartialPageCollection.build({
                project: this._project,
                key: key,
                repository: this._repo
            });
            this._commentsByKey[key] = comments;
        }

        return comments;
    }
}

const repositories = {};

const find = function(project) {
    let r = repositories[project.id];
    if(!r) {
        r = new CommentCollectionRepository(project);
        repositories[project.id] = r;
    }
    return r;
};

const saveDraft = function(project, comment) {
    let r = repositories[project.id];
    if(!r) {
        r = new CommentCollectionRepository(project);
        repositories[project.id] = r;
    }
    r._draftComment = new Comment(comment);
    return r._draftComment;
};

const getDraft = function(project) {
    let r = repositories[project.id];
    if(!r) {
        return '';
    }
    return r._draftComment;
};

const clearDraft = function(project) {
    let r = repositories[project.id];
    if(!r) {
        return '';
    }
    r._draftComment = '';
};
module.exports = {
    find: find,
    saveDraft: saveDraft,
    getDraft: getDraft,
    clearDraft: clearDraft
};



// WEBPACK FOOTER //
// ./communication/domain/repository/comment-collection.js